import { render, staticRenderFns } from "./manorStuDaily.vue?vue&type=template&id=01d18ca2&"
import script from "./manorStuDaily.vue?vue&type=script&lang=js&"
export * from "./manorStuDaily.vue?vue&type=script&lang=js&"
import style0 from "./manorStuDaily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports